<div class="modal-dialog" role="document">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm" (click)="onClose()" [attr.data-dismiss]="'modal'"
				type="button">Chiudi</button>
		</p>
		<div class="col-sm-12 coldx">
			<h3>Ricerca precedenti</h3>
			
			<app-ricerca-precedenti-core [pratica] = "pratica" [disableSave]="false" (onReturn)="retrieveEventSave()"></app-ricerca-precedenti-core>
			
		</div>

	</div>
</div>